/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/shipping-and-fulfillment/fulfillment
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyFulfillmentEventKey,
  ShopifyFulfillmentEventToFulfillmentKey,
  ShopifyFulfillmentKey,
  ShopifyFulfillmentLineItemKey,
  ShopifyFulfillmentLineItemToFulfillmentKey,
  ShopifyFulfillmentToFulfillmentEventsKey,
  ShopifyFulfillmentToFulfillmentLineItemsKey,
  ShopifyFulfillmentToLocationKey,
  ShopifyFulfillmentToOrderKey,
  ShopifyFulfillmentToShopKey,
  ShopifyLocationKey,
  ShopifyOrderKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyFulfillmentKey,
  "2022-01": {
    name: "Shopify Fulfillment",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Fulfillment Events",
        fieldType: FieldType.HasMany,
        key: ShopifyFulfillmentToFulfillmentEventsKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyFulfillmentEventKey,
          inverseFieldKey: ShopifyFulfillmentEventToFulfillmentKey,
        },
      },
      {
        name: "Fulfillment Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyFulfillmentToFulfillmentLineItemsKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "line_items" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyFulfillmentLineItemKey,
          inverseFieldKey: ShopifyFulfillmentLineItemToFulfillmentKey,
        },
      },
      {
        name: "Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentToLocationKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "location_id" } },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      {
        name: "Notify Customer",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "notify_customer" } },
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentToOrderKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "order_id" } },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Origin Address",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "origin_address" } },
      },
      {
        name: "Receipt",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "receipt" } },
      },
      {
        name: "Service",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "service" } },
      },
      {
        name: "Shipment Status",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shipment_status" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Status",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "status" } },
      },
      {
        name: "Tracking Company",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tracking_company" } },
      },
      {
        name: "Tracking Numbers",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tracking_numbers" } },
      },
      {
        name: "Tracking URLs",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tracking_urls" } },
      },
      {
        name: "Variant Inventory Management",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "variant_inventory_management" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "order" },
  },
  "2025-04": {
    graphQLTypename: "Fulfillment",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Fulfillment Events",
        fieldType: FieldType.HasMany,
        key: ShopifyFulfillmentToFulfillmentEventsKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyFulfillmentEventKey,
          inverseFieldKey: ShopifyFulfillmentEventToFulfillmentKey,
        },
      },
      {
        name: "Fulfillment Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyFulfillmentToFulfillmentLineItemsKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "line_items",
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyFulfillmentLineItemKey,
          inverseFieldKey: ShopifyFulfillmentLineItemToFulfillmentKey,
        },
      },
      {
        name: "Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentToLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "location_id",
            graphQLFieldKey: "location",
            graphQLSelection: "id",
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "name",
            graphQLFieldKey: "name",
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Notify Customer",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "notify_customer" } },
        isDeleted: true,
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentToOrderKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "order_id",
            graphQLFieldKey: "order",
            graphQLSelection: "id",
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Origin Address",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "origin_address",
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
            graphQLFieldKey: "originAddress",
            graphQLSelection: `
          address1
          address2
          city
          countryCode
          provinceCode
          zip
          `,
          },
        },
      },
      {
        name: "Receipt",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "receipt",
            deprecated: true,
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Service",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "service",
            graphQLFieldKey: "service",
            graphQLSelection: "handle",
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Shipment Status",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "shipment_status",
            deprecated: true,
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
            graphQLFieldKey: "updatedAt",
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "status",
            graphQLFieldKey: "status",
            isShopifyEnum: true,
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "CANCELLED" },
            { name: "ERROR" },
            { name: "FAILURE" },
            { name: "SUCCESS" },
            { name: "OPEN" },
            { name: "PENDING" },
          ],
        },
      },
      {
        name: "Tracking Company",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tracking_company",
            graphQLFieldKey: "trackingCompany",
            skipGraphQLSelection: true,
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Tracking Numbers",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tracking_numbers",
            graphQLFieldKey: "trackingNumbers",
            skipGraphQLSelection: true,
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Tracking URLs",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tracking_urls",
            graphQLFieldKey: "trackingUrls",
            skipGraphQLSelection: true,
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Variant Inventory Management",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "variant_inventory_management" } },
        isDeleted: true,
      },
      {
        name: "Tracking Number",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tracking_number",
            graphQLFieldKey: "trackingNumber",
            skipGraphQLSelection: true,
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Tracking URL",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tracking_url",
            graphQLFieldKey: "trackingUrl",
            skipGraphQLSelection: true,
            availableInWebhook: ["fulfillments/create", "fulfillments/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Delivered At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "deliveredAt", graphQLOnlyField: true } },
      },
      {
        name: "Delivered At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "deliveredAt", graphQLOnlyField: true } },
      },
      {
        name: "Display Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "displayStatus", graphQLOnlyField: true, isShopifyEnum: true },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "ATTEMPTED_DELIVERY" },
            { name: "CANCELED" },
            { name: "CONFIRMED" },
            { name: "DELAYED" },
            { name: "DELIVERED" },
            { name: "FAILURE" },
            { name: "FULFILLED" },
            { name: "IN_TRANSIT" },
            { name: "LABEL_PRINTED" },
            { name: "LABEL_PURCHASED" },
            { name: "LABEL_VOIDED" },
            { name: "MARKED_AS_FULFILLED" },
            { name: "NOT_DELIVERED" },
            { name: "OUT_FOR_DELIVERY" },
            { name: "PICKED_UP" },
            { name: "READY_FOR_PICKUP" },
            { name: "SUBMITTED" },
          ],
        },
      },
      {
        name: "Estimated Delivery At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "estimatedDeliveryAt", graphQLOnlyField: true } },
      },
      {
        name: "In Transit At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "inTransitAt", graphQLOnlyField: true } },
      },
      {
        name: "Requires Shipping",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "requiresShipping", graphQLOnlyField: true } },
      },
      {
        name: "Total Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "totalQuantity", graphQLOnlyField: true } },
      },
      {
        name: "Tracking Info",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "trackingInfo",
            graphQLOnlyField: true,
            graphQLSelection: `
          company
          number
          url
          `,
          },
        },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      parent: "orders",
      resource: "order.fulfillments",
      skipPagination: true,
    },
  },
  "2025-07": {
    fields: [
      {
        name: "Display Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "displayStatus", graphQLOnlyField: true, isShopifyEnum: true },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "ATTEMPTED_DELIVERY" },
            { name: "CANCELED" },
            { name: "CONFIRMED" },
            { name: "DELAYED" },
            { name: "DELIVERED" },
            { name: "FAILURE" },
            { name: "FULFILLED" },
            { name: "IN_TRANSIT" },
            { name: "LABEL_PRINTED" },
            { name: "LABEL_PURCHASED" },
            { name: "LABEL_VOIDED" },
            { name: "MARKED_AS_FULFILLED" },
            { name: "NOT_DELIVERED" },
            { name: "OUT_FOR_DELIVERY" },
            { name: "PICKED_UP" },
            { name: "READY_FOR_PICKUP" },
            { name: "SUBMITTED" },
            { name: "CARRIER_PICKED_UP" },
          ],
        },
      },
    ],
  },
};

export const ShopifyFulfillment = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
